/* Script de la page produit Ganzjahresdecke (.lx) - Copie Conforme Lunora.
   Aucun texte visible en dur, aucune chaîne HTML en dur : tout passe par <template> et [data-lx-donnees]. */
(function () {
  "use strict";
  if (window.__lxPage) return;
  window.__lxPage = true;

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function racine() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"; }

  var COULEURS_HEX = [
    ["kuesten", "#5B82A6"],
    ["küsten", "#5B82A6"],
    ["creme", "#D6C7B2"],
    ["sand", "#D6C7B2"],
    ["schwarz", "#232529"],
    ["mitternacht", "#232529"],
    ["schnee", "#F7F7F5"],
    ["mondstein", "#7A7E85"],
    ["wolken", "#B4B8BC"],
    ["mint", "#8FA395"],
    ["salbei", "#8FA395"],
    ["abend", "#C86D51"],
    ["terrakotta", "#C86D51"],
    ["kamin", "#8B2E3B"],
    ["altrosa", "#D9A7A0"],
    ["flieder", "#9B86B4"],
    ["anthrazit", "#424549"],
    ["marine", "#24364D"]
  ];

  function hexPourCouleur(nom) {
    var n = String(nom || "").toLowerCase();
    for (var i = 0; i < COULEURS_HEX.length; i++) {
      if (n.indexOf(COULEURS_HEX[i][0]) !== -1) return COULEURS_HEX[i][1];
    }
    return "#5B82A6";
  }

  // ---------- 1. Pilule d'expédition dynamique style Koré (DE / AT / CH) ----------
  var JOURS_DE = ["Sonn.", "Mont.", "Dien.", "Mitt.", "Donn.", "Frei.", "Sam."];
  var MOIS_DE = ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."];

  function calculerDateExpedition() {
    var now = new Date();
    var berlinStr = now.toLocaleString("en-US", { timeZone: "Europe/Berlin" });
    var d = new Date(berlinStr);
    if (isNaN(d.getTime())) d = now;
    var ajoutes = 0;
    while (ajoutes < 2) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) ajoutes++;
    }
    return JOURS_DE[d.getDay()] + ", " + d.getDate() + ". " + MOIS_DE[d.getMonth()];
  }

  function afficherDrapeau(code) {
    if (code !== "DE" && code !== "AT" && code !== "CH") return;
    $$("[data-lx-flag-svg]").forEach(function (svg) {
      svg.hidden = svg.getAttribute("data-lx-flag-svg") !== code;
    });
  }

  function initExpedition() {
    var dateTxt = calculerDateExpedition();
    $$("[data-lx-exp-date]").forEach(function (el) { el.textContent = dateTxt; });

    if (window.location.protocol.indexOf("http") === 0) {
      fetch("/browsing_context_suggestions.json", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var code = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
          if (code) afficherDrapeau(code);
        })
        .catch(function () {});
    }
  }

  // ---------- 2. Tiroir Panier Latéral style Harper (snippets/lx-panier.liquid) ----------
  var memoirePanierLocal = { items: [], item_count: 0, total_price: 0 };
  var indexVariantesGlobal = {};

  function formaterCents(cents) {
    var panierEl = $("[data-lx-panier]");
    var sym = (panierEl && panierEl.getAttribute("data-symbole")) || "€";
    var dev = (panierEl && panierEl.getAttribute("data-devise")) || "EUR";
    var val = (Math.max(0, cents || 0) / 100).toFixed(2);
    if (dev === "CHF") {
      return sym + " " + val;
    }
    return val.replace(".", ",") + " " + sym;
  }

  function imagePanierPourCouleur(panierEl, texteOpt) {
    if (!panierEl) return "";
    var t = String(texteOpt || "").toLowerCase();
    var map = [
      ["mondstein", "data-img-mondstein"],
      ["mint", "data-img-mint"],
      ["salbei", "data-img-mint"],
      ["mitternacht", "data-img-schwarz"],
      ["schwarz", "data-img-schwarz"],
      ["schnee", "data-img-schnee"],
      ["creme", "data-img-creme"],
      ["sand", "data-img-creme"],
      ["kamin", "data-img-kamin"],
      ["abend", "data-img-abend"],
      ["terrakotta", "data-img-abend"],
      ["flieder", "data-img-flieder"],
      ["kuesten", "data-img-kuesten"],
      ["küsten", "data-img-kuesten"]
    ];
    for (var i = 0; i < map.length; i++) {
      if (t.indexOf(map[i][0]) !== -1) {
        var u = panierEl.getAttribute(map[i][1]);
        if (u) return u;
      }
    }
    return panierEl.getAttribute("data-img-defaut") || "";
  }

  function kissenPourCouleur(panierEl, texteOpt) {
    if (!panierEl) return "";
    var t = String(texteOpt || "").toLowerCase();
    var map = [
      ["mondstein", "data-kissen-mondstein"],
      ["mint", "data-kissen-mint"],
      ["salbei", "data-kissen-mint"],
      ["mitternacht", "data-kissen-schwarz"],
      ["schwarz", "data-kissen-schwarz"],
      ["schnee", "data-kissen-schnee"],
      ["creme", "data-kissen-creme"],
      ["sand", "data-kissen-creme"],
      ["kamin", "data-kissen-kamin"],
      ["abend", "data-kissen-abend"],
      ["terrakotta", "data-kissen-abend"],
      ["flieder", "data-kissen-flieder"],
      ["kuesten", "data-kissen-kuesten"],
      ["küsten", "data-kissen-kuesten"]
    ];
    for (var i = 0; i < map.length; i++) {
      if (t.indexOf(map[i][0]) !== -1) {
        var u = panierEl.getAttribute(map[i][1]);
        if (u) return u;
      }
    }
    return panierEl.getAttribute("data-kissen-defaut") || panierEl.getAttribute("data-cadeau-img") || "";
  }

  function extraireNomCouleur(optsStr, vInfo) {
    if (vInfo && vInfo.opt1) return vInfo.opt1;
    var s = String(optsStr || "");
    if (s.indexOf("/") !== -1) return s.split("/")[0].trim();
    return s.trim();
  }

  function rendrePanier(panier) {
    var panierEl = $("[data-lx-panier]");
    if (!panierEl || !panier) return;
    var lignesEl = $("[data-lx-panier-lignes]", panierEl);
    var videEl = $("[data-lx-panier-vide]", panierEl);
    var piedEl = $("[data-lx-panier-pied]", panierEl);
    var livEl = $("[data-lx-panier-livraison]", panierEl);
    var nbEl = $("[data-lx-panier-nb]", panierEl);
    var totEl = $("[data-lx-panier-total]", panierEl);
    var totPleinEl = $("[data-lx-panier-plein]", panierEl);
    var ecoLigneEl = $("[data-lx-panier-ligne-eco]", panierEl);
    var ecoEl = $("[data-lx-panier-eco]", panierEl);
    var totBtnEl = $("[data-lx-panier-total-btn]", panierEl);
    var tplLigne = $("[data-lx-tpl-ligne]", panierEl);
    var tplCadeau = $("[data-lx-tpl-cadeau]", panierEl);

    var items = panier.items || [];
    var nbTotal = panier.item_count || items.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
    var pleinArticles = 0;

    $$("[data-lx-compteur-panier]").forEach(function (el) { el.textContent = String(nbTotal); });
    if (nbEl) nbEl.textContent = String(nbTotal);
    if (videEl) videEl.hidden = nbTotal > 0;
    if (piedEl) piedEl.hidden = nbTotal === 0;
    if (livEl) livEl.hidden = nbTotal === 0;

    if (lignesEl) {
      lignesEl.innerHTML = "";
      items.forEach(function (it) {
        if (!tplLigne || !tplLigne.content) return;
        var frag = tplLigne.content.cloneNode(true);
        var vInfo = indexVariantesGlobal[it.variant_id || it.id] || {};
        var opts = it.variant_title || (vInfo.opt1 && vInfo.opt2 ? vInfo.opt1 + " / " + vInfo.opt2 : "");
        var imgParCouleur = imagePanierPourCouleur(panierEl, opts || vInfo.opt1 || "");
        var fallbackImg = ($("[data-lx-img-principale]") && $("[data-lx-img-principale]").src) || "";
        var imgUrl = imgParCouleur || vInfo.thumb || it.image || (it.featured_image && it.featured_image.url) || vInfo.img || fallbackImg;
        var titreProd = it.product_title || it.title || "";
        var q = it.quantity || 1;
        var cle = it.key || String(it.variant_id || it.id);
        var prixLigne = typeof it.final_line_price === "number" ? it.final_line_price : (vInfo.prixCents || 8490) * q;
        var prixUnitaire = Math.round(prixLigne / Math.max(1, q));
        var pleinUnitaire = vInfo.pleinCents || (it.original_price > prixUnitaire ? it.original_price : 0) || (prixUnitaire + 5000);
        var pleinLigne = pleinUnitaire * q;
        pleinArticles += pleinLigne;

        var imgEl = $("[data-lx-item-img]", frag);
        if (imgEl && imgUrl) imgEl.src = imgUrl;
        var nomEl = $("[data-lx-item-nom]", frag);
        if (nomEl) nomEl.textContent = titreProd;
        var optsEl = $("[data-lx-item-opts]", frag);
        if (optsEl) {
          optsEl.textContent = opts;
          optsEl.hidden = !opts;
        }
        var qteEl = $("[data-lx-item-qte]", frag);
        if (qteEl) qteEl.textContent = String(q);

        $$("[data-lx-panier-qte]", frag).forEach(function (b) {
          b.setAttribute("data-cle", cle);
          b.setAttribute("data-q", String(q));
        });
        var btnRet = $("[data-lx-panier-retirer]", frag);
        if (btnRet) btnRet.setAttribute("data-cle", cle);

        var pleinEl = $("[data-lx-item-plein]", frag);
        if (pleinEl && pleinLigne > prixLigne) {
          pleinEl.textContent = formaterCents(pleinLigne);
          pleinEl.hidden = false;
        }
        var prixEl = $("[data-lx-item-prix]", frag);
        if (prixEl) prixEl.textContent = formaterCents(prixLigne);

        lignesEl.appendChild(frag);
      });

      var cadeauTitre = panierEl.getAttribute("data-cadeau-titre") || "";
      if (nbTotal > 0 && cadeauTitre && tplCadeau && tplCadeau.content) {
        var baseCadTitre = cadeauTitre.replace(/^2\s+/, "").replace(/\s*\([^)]*\)\s*$/, "").trim();
        var groupesCouleur = [];
        var mapCouleurs = {};
        items.forEach(function (it) {
          var vInfo = indexVariantesGlobal[it.variant_id || it.id] || {};
          var opts = it.variant_title || (vInfo.opt1 && vInfo.opt2 ? vInfo.opt1 + " / " + vInfo.opt2 : "");
          var nomCoul = extraireNomCouleur(opts, vInfo) || "Küstenblau";
          var q = it.quantity || 1;
          if (!mapCouleurs[nomCoul]) {
            mapCouleurs[nomCoul] = { couleur: nomCoul, qte: 0 };
            groupesCouleur.push(mapCouleurs[nomCoul]);
          }
          mapCouleurs[nomCoul].qte += q;
        });

        groupesCouleur.forEach(function (grp) {
          var fragCad = tplCadeau.content.cloneNode(true);
          var nbTaies = grp.qte * 2;
          var cadNomEl = $("[data-lx-cad-nom]", fragCad);
          if (cadNomEl) {
            cadNomEl.textContent = nbTaies + "x " + baseCadTitre + (grp.couleur ? " · " + grp.couleur : "");
          }
          var cadImgEl = $("[data-lx-cad-img]", fragCad);
          var imgKissen = kissenPourCouleur(panierEl, grp.couleur);
          if (cadImgEl && imgKissen) cadImgEl.src = imgKissen;
          var cadPleinEl = $("[data-lx-cad-plein]", fragCad);
          if (cadPleinEl) {
            cadPleinEl.textContent = formaterCents(grp.qte * 4990);
            cadPleinEl.hidden = false;
          }
          lignesEl.appendChild(fragCad);
        });
      }
    }

    var totalCents = panier.total_price || 0;
    var pleinTotal = pleinArticles + (nbTotal * 4990);
    var ecoTotale = Math.max(0, pleinTotal - totalCents);
    var totalStr = formaterCents(totalCents);
    if (totEl) totEl.textContent = totalStr;
    if (totBtnEl) totBtnEl.textContent = totalStr;
    if (totPleinEl) {
      if (pleinTotal > totalCents && nbTotal > 0) {
        totPleinEl.textContent = formaterCents(pleinTotal);
        totPleinEl.hidden = false;
      } else {
        totPleinEl.hidden = true;
      }
    }
    if (ecoLigneEl && ecoEl) {
      if (ecoTotale > 0 && nbTotal > 0) {
        ecoEl.textContent = "- " + formaterCents(ecoTotale);
        ecoLigneEl.hidden = false;
      } else {
        ecoLigneEl.hidden = true;
      }
    }
  }

  function ouvrirPanier(dejaRendu) {
    var panierEl = $("[data-lx-panier]");
    if (!panierEl) return;
    if (panierEl.parentNode !== document.body) {
      document.body.appendChild(panierEl);
    }
    panierEl.hidden = false;
    document.body.style.overflow = "hidden";
    $$("[data-lx-collante], [data-lx-remonter]").forEach(function (el) { el.style.visibility = "hidden"; });
    if (dejaRendu) return;
    if (window.location.protocol.indexOf("http") === 0) {
      fetch(racine() + "cart.js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) rendrePanier(c); })
        .catch(function () {});
    } else {
      rendrePanier(memoirePanierLocal);
    }
  }

  function fermerPanier() {
    var panierEl = $("[data-lx-panier]");
    if (!panierEl) return;
    panierEl.hidden = true;
    document.body.style.overflow = "";
    $$("[data-lx-collante], [data-lx-remonter]").forEach(function (el) { el.style.visibility = ""; });
  }

  function majQuantitePanier(cle, nouvelleQte) {
    if (window.location.protocol.indexOf("http") === 0) {
      fetch(racine() + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: cle, quantity: Math.max(0, nouvelleQte) })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) rendrePanier(c); })
        .catch(function () {});
    } else {
      memoirePanierLocal.items = memoirePanierLocal.items.filter(function (it) {
        if (String(it.key) === String(cle)) {
          it.quantity = Math.max(0, nouvelleQte);
          it.final_line_price = it.price * it.quantity;
        }
        return it.quantity > 0;
      });
      memoirePanierLocal.item_count = memoirePanierLocal.items.reduce(function (s, i) { return s + i.quantity; }, 0);
      memoirePanierLocal.total_price = memoirePanierLocal.items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      rendrePanier(memoirePanierLocal);
    }
  }

  // ---------- 3. Fiche produit (Galerie, Variantes, Paliers, Guide Koré, Ajout Panier) ----------
  function initFiche(fiche) {
    if (fiche.__lx) return;
    fiche.__lx = true;

    var donnees = { variantes: [] };
    try { donnees = JSON.parse($("[data-lx-donnees]", fiche).textContent); } catch (e) {}
    var variantes = donnees.variantes || [];
    variantes.forEach(function (v) { indexVariantesGlobal[v.id] = v; });

    var champVar = $("[data-lx-variante]", fiche);
    var btnsCouleur = $$("[data-lx-choix-couleur]", fiche);
    var btnsTaille = $$("[data-lx-choix-taille]", fiche);
    var selectsCouleur = $$("[data-lx-select-couleur]", fiche);
    var selectsTaille = $$("[data-lx-select-taille]", fiche);
    var paliers = $$("[data-lx-palier]", fiche);
    var bouton = $("[data-lx-ajouter]", fiche);
    var boutonCollante = $("[data-lx-ajouter-collante]", fiche);
    var retour = $("[data-lx-retour]", fiche);

    // 3a. Galerie fluide (14 vues + auto-centrage de la vignette active)
    var piste = $("[data-lx-piste]", fiche);
    var barreVignettes = $(".lx-galerie__vignettes", fiche);
    var vignettes = $$("[data-lx-vignette]", fiche);
    var btnPrec = $("[data-lx-prec]", fiche);
    var btnSuiv = $("[data-lx-suiv]", fiche);

    function indiceGalerie() {
      return piste ? Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth)) : 0;
    }
    function activerGifSlide(idx) {
      if (!piste) return;
      [idx, idx + 1].forEach(function (k) {
        var vue = piste.children[k];
        if (!vue) return;
        var img = $("[data-lx-gif-src]", vue);
        if (img) {
          var gif = img.getAttribute("data-lx-gif-src");
          img.removeAttribute("data-lx-gif-src");
          lancerAnim(img, gif);
        }
      });
    }
    function centrerVignette(idx) {
      var v = vignettes[idx];
      if (!barreVignettes || !v) return;
      var cibleLeft = v.offsetLeft - (barreVignettes.clientWidth / 2) + (v.clientWidth / 2);
      barreVignettes.scrollTo({ left: Math.max(0, cibleLeft), behavior: "smooth" });
    }
    function allerAGalerie(i) {
      if (!piste) return;
      var total = piste.children.length;
      if (!total) return;
      var cible = ((i % total) + total) % total;
      activerGifSlide(cible);
      piste.scrollTo({ left: piste.clientWidth * cible, behavior: "smooth" });
      vignettes.forEach(function (b, k) {
        b.setAttribute("aria-current", k === cible ? "true" : "false");
      });
      centrerVignette(cible);
    }
    vignettes.forEach(function (b) {
      b.addEventListener("click", function () {
        allerAGalerie(+b.getAttribute("data-lx-vignette"));
      });
    });
    if (btnPrec) btnPrec.addEventListener("click", function () { allerAGalerie(indiceGalerie() - 1); });
    if (btnSuiv) btnSuiv.addEventListener("click", function () { allerAGalerie(indiceGalerie() + 1); });
    if (piste) {
      piste.addEventListener("touchstart", function () { activerGifSlide(indiceGalerie()); }, { passive: true, once: true });
      piste.addEventListener("pointerdown", function () { activerGifSlide(indiceGalerie()); }, { passive: true, once: true });
      var timerScroll;
      piste.addEventListener("scroll", function () {
        clearTimeout(timerScroll);
        timerScroll = setTimeout(function () {
          var idx = indiceGalerie();
          activerGifSlide(idx);
          vignettes.forEach(function (b, k) {
            b.setAttribute("aria-current", k === idx ? "true" : "false");
          });
          centrerVignette(idx);
        }, 60);
      }, { passive: true });
    }

    // Coloration des pastilles de couleur dans les menus dropdown (.lx-dd)
    $$("[data-lx-pastille-nom]", fiche).forEach(function (el) {
      el.style.backgroundColor = hexPourCouleur(el.getAttribute("data-lx-pastille-nom"));
    });

    // 3b. Variantes (Farbe x Größe) et Paliers
    var couleurActive = btnsCouleur.length ? btnsCouleur[0].getAttribute("data-lx-choix-couleur") : null;
    btnsCouleur.forEach(function (b) {
      if (b.classList.contains("is-active")) couleurActive = b.getAttribute("data-lx-choix-couleur");
    });
    if (selectsCouleur.length && selectsCouleur[0].value) couleurActive = selectsCouleur[0].value;

    var tailleActive = btnsTaille.length ? btnsTaille[0].getAttribute("data-lx-choix-taille") : null;
    btnsTaille.forEach(function (b) {
      if (b.classList.contains("is-active")) tailleActive = b.getAttribute("data-lx-choix-taille");
    });
    if (selectsTaille.length && selectsTaille[0].value) tailleActive = selectsTaille[0].value;

    function trouverVariante(coul, tail) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var ok1 = !coul || v.opt1 === coul;
        var ok2 = !tail || v.opt2 === tail;
        if (ok1 && ok2) return v;
      }
      return variantes[0] || null;
    }

    function variantesCouple() {
      var v = trouverVariante(couleurActive, tailleActive);
      return v ? [v] : [];
    }

    function indicePalierChoisi() {
      for (var i = 0; i < paliers.length; i++) {
        var inp = $("input", paliers[i]);
        if (inp && inp.checked) return i;
      }
      return 0;
    }

    function infoPalier(listeC, vBase, k) {
      var p = (vBase.paliers && vBase.paliers[k]) || null;
      if (!p) return null;
      return {
        idVar: vBase.id,
        qSend: p.q || 1,
        total: p.total,
        plein: p.plein,
        eco: p.eco,
        barre: p.barre
      };
    }

    function majLignePalierVisuel(ligneEl) {
      var selC = $("[data-lx-select-couleur]", ligneEl);
      var selT = $("[data-lx-select-taille]", ligneEl);
      var pastille = $("[data-lx-pastille-couleur]", ligneEl);
      var img = $("[data-lx-palier-img]", ligneEl);
      var cVal = selC ? selC.value : couleurActive;
      var tVal = selT ? selT.value : tailleActive;
      if (pastille) pastille.style.backgroundColor = hexPourCouleur(cVal);
      var vLigne = trouverVariante(cVal, tVal);
      if (img && vLigne && vLigne.thumb) {
        img.removeAttribute("srcset");
        img.src = vLigne.thumb;
      }
      $$("[data-lx-dd]", ligneEl).forEach(function (dd) {
        var sel = $("select", dd);
        if (!sel) return;
        var valEl = $("[data-lx-dd-val]", dd);
        if (valEl) valEl.textContent = sel.value;
        $$("[data-lx-dd-item]", dd).forEach(function (it) {
          it.classList.toggle("is-active", it.getAttribute("data-lx-dd-item") === sel.value);
        });
      });
    }

    function majAffichage(changerImage, propagerSelects) {
      var listeC = variantesCouple();
      var v = listeC[0];
      if (!v) return;
      var idxP = indicePalierChoisi();
      var actifP = infoPalier(listeC, v, idxP) || infoPalier(listeC, v, 0);
      if (champVar) champVar.value = (actifP && actifP.idVar) ? actifP.idVar : v.id;

      var txtCouleur = $("[data-lx-couleur-active]", fiche);
      if (txtCouleur && v.opt1) txtCouleur.textContent = v.opt1;
      var txtTaille = $("[data-lx-taille-active]", fiche);
      if (txtTaille && v.opt2) txtTaille.textContent = v.opt2;

      var colCouleur = $("[data-lx-collante-couleur]", fiche);
      if (colCouleur && v.opt1) colCouleur.textContent = v.opt1;
      var colTaille = $("[data-lx-collante-taille]", fiche);
      if (colTaille && v.opt2) colTaille.textContent = v.opt2;

      if (propagerSelects !== false) {
        selectsCouleur.forEach(function (s) { if (v.opt1 && s.value !== v.opt1) s.value = v.opt1; });
        selectsTaille.forEach(function (s) { if (v.opt2 && s.value !== v.opt2) s.value = v.opt2; });
      }

      $$(".lx-palier__ligne-var", fiche).forEach(majLignePalierVisuel);

      if (changerImage && v.img) {
        var imgP = $("[data-lx-img-principale]", fiche);
        if (imgP) { imgP.removeAttribute("srcset"); imgP.src = v.img; }
        var vigP = $("[data-lx-vignette-principale]", fiche);
        if (vigP && v.thumb) { vigP.removeAttribute("srcset"); vigP.src = v.thumb; }
        var colImg = $("[data-lx-collante-img]", fiche);
        if (colImg && v.thumb) { colImg.removeAttribute("srcset"); colImg.src = v.thumb; }
        allerAGalerie(0);
      }

      paliers.forEach(function (elPalier, k) {
        elPalier.classList.toggle("is-active", k === idxP);
        var infoP = infoPalier(listeC, v, k);
        if (!infoP) return;
        var elTot = $("[data-lx-total]", elPalier);
        var elPl = $("[data-lx-plein]", elPalier);
        if (elTot) elTot.textContent = infoP.total;
        if (elPl) {
          elPl.textContent = infoP.plein;
          elPl.hidden = !infoP.barre;
        }
      });

      if (actifP) {
        var pTot = $("[data-lx-prix-total]", fiche);
        var pPl = $("[data-lx-prix-plein]", fiche);
        var pEco = $("[data-lx-prix-eco]", fiche);
        var bTot = $("[data-lx-bouton-total]", fiche);
        var cTot = $("[data-lx-collante-total]", fiche);
        var cPl = $("[data-lx-collante-plein]", fiche);

        if (pTot) pTot.textContent = actifP.total;
        if (pPl) { pPl.textContent = actifP.plein; pPl.hidden = !actifP.barre; }
        if (bTot) bTot.textContent = actifP.total;
        if (cTot) cTot.textContent = actifP.total;
        if (cPl) { cPl.textContent = actifP.plein; cPl.hidden = !actifP.barre; }
        if (pEco) {
          var mod = donnees.modeleEco || "";
          pEco.textContent = mod.replace("[montant]", actifP.eco);
          pEco.hidden = !actifP.barre || !mod;
        }
      }

      var libBtn = $("[data-lx-bouton-libelle]", fiche);
      if (bouton) bouton.disabled = !v.dispo;
      if (boutonCollante) boutonCollante.disabled = !v.dispo;
      if (libBtn) libBtn.textContent = v.dispo ? (donnees.texteBouton || "") : (donnees.texteEpuise || "");
    }

    function choisirCouleur(val, propager) {
      couleurActive = val;
      btnsCouleur.forEach(function (x) {
        var actif = x.getAttribute("data-lx-choix-couleur") === val;
        x.classList.toggle("is-active", actif);
        x.setAttribute("aria-pressed", actif ? "true" : "false");
      });
      majAffichage(true, propager);
    }

    function choisirTaille(val, propager) {
      tailleActive = val;
      btnsTaille.forEach(function (x) {
        var actif = x.getAttribute("data-lx-choix-taille") === val;
        x.classList.toggle("is-active", actif);
        x.setAttribute("aria-pressed", actif ? "true" : "false");
      });
      majAffichage(false, propager);
    }

    btnsCouleur.forEach(function (b) {
      b.addEventListener("click", function () { choisirCouleur(b.getAttribute("data-lx-choix-couleur"), true); });
    });
    selectsCouleur.forEach(function (s) {
      s.addEventListener("change", function () {
        var ligne = s.closest(".lx-palier__ligne-var");
        if (ligne) majLignePalierVisuel(ligne);
        choisirCouleur(s.value, false);
      });
    });

    btnsTaille.forEach(function (b) {
      b.addEventListener("click", function () { choisirTaille(b.getAttribute("data-lx-choix-taille"), true); });
    });
    selectsTaille.forEach(function (s) {
      s.addEventListener("change", function () {
        var ligne = s.closest(".lx-palier__ligne-var");
        if (ligne) majLignePalierVisuel(ligne);
        choisirTaille(s.value, false);
      });
    });

    function fermerTousDropdowns(sauf) {
      $$("[data-lx-dd].is-open", fiche).forEach(function (dd) {
        if (dd === sauf) return;
        dd.classList.remove("is-open");
        var btn = $("[data-lx-dd-btn]", dd);
        var menu = $("[data-lx-dd-menu]", dd);
        if (btn) btn.setAttribute("aria-expanded", "false");
        if (menu) menu.hidden = true;
      });
    }

    $$("[data-lx-dd]", fiche).forEach(function (dd) {
      var btn = $("[data-lx-dd-btn]", dd);
      var menu = $("[data-lx-dd-menu]", dd);
      var sel = $("select", dd);
      if (!btn || !menu || !sel) return;

      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var palier = dd.closest("[data-lx-palier]");
        if (palier) {
          var inp = $("input[type=radio]", palier);
          if (inp && !inp.checked) {
            inp.checked = true;
            majAffichage(false, false);
          }
        }
        var ouvert = dd.classList.contains("is-open");
        fermerTousDropdowns(dd);
        dd.classList.toggle("is-open", !ouvert);
        btn.setAttribute("aria-expanded", !ouvert ? "true" : "false");
        menu.hidden = ouvert;
      });

      $$("[data-lx-dd-item]", dd).forEach(function (itemBtn) {
        itemBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          var val = itemBtn.getAttribute("data-lx-dd-item") || "";
          sel.value = val;
          dd.classList.remove("is-open");
          btn.setAttribute("aria-expanded", "false");
          menu.hidden = true;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });

    paliers.forEach(function (p) {
      var inp = $("input", p);
      if (inp) inp.addEventListener("change", function () { majAffichage(false, false); });
      p.addEventListener("click", function (e) {
        if (e.target && (e.target.tagName === "SELECT" || e.target.tagName === "OPTION" || (e.target.closest && e.target.closest("[data-lx-dd]")))) return;
        if (inp && !inp.checked) {
          inp.checked = true;
          majAffichage(false, false);
        }
      });
    });

    majAffichage(false, true);

    // 3c. Modale Guide des tailles orienté conversion (style Koré)
    var btnsGuide = $$("[data-lx-ouvrir-guide]", fiche);
    var modalGuide = $("[data-lx-modal-guide]", fiche);
    var btnFermerGuide = $("[data-lx-fermer-guide]", fiche);
    var cartesLit = $$("[data-lx-guide-lit]", fiche);
    var resTailleEl = $("[data-lx-guide-res-taille]", fiche);
    var resDetailEl = $("[data-lx-guide-res-detail]", fiche);
    var btnAppliquerGuide = $("[data-lx-guide-appliquer]", fiche);
    var recoPill = $("[data-lx-guide-reco-pill]", fiche);
    var recoTxt = $("[data-lx-guide-reco-texte]", fiche);
    var tailleConseillee = tailleActive || "";
    var palierConseille = 0;

    function selectionnerCarteLit(btnLit) {
      if (!btnLit) return;
      cartesLit.forEach(function (b) { b.classList.toggle("is-selected", b === btnLit); });
      tailleConseillee = btnLit.getAttribute("data-taille") || "";
      palierConseille = parseInt(btnLit.getAttribute("data-palier") || "0", 10) || 0;
      var machine = btnLit.getAttribute("data-machine") || "";
      var usage = btnLit.getAttribute("data-usage") || "";
      if (resTailleEl) resTailleEl.textContent = tailleConseillee;
      if (resDetailEl) resDetailEl.textContent = usage + (machine ? " · " + machine : "");
      $$("[data-lx-guide-row]", fiche).forEach(function (tr) {
        tr.classList.toggle("is-highlighted", tr.getAttribute("data-lx-guide-row") === tailleConseillee);
      });
    }

    if (cartesLit.length) {
      selectionnerCarteLit(cartesLit[0]);
      cartesLit.forEach(function (btnLit) {
        btnLit.addEventListener("click", function () { selectionnerCarteLit(btnLit); });
      });
    }

    if (btnAppliquerGuide) {
      btnAppliquerGuide.addEventListener("click", function () {
        if (palierConseille > 0 && paliers[palierConseille - 1]) {
          var inpP = $("input", paliers[palierConseille - 1]);
          if (inpP) inpP.checked = true;
        }
        choisirTaille(tailleConseillee, true);
        if (recoPill && recoTxt) {
          var pref = donnees.guideRecoPrefixe || "";
          recoTxt.textContent = pref + " " + tailleConseillee;
          recoPill.hidden = false;
        }
        if (modalGuide) {
          if (typeof modalGuide.close === "function") modalGuide.close();
          else modalGuide.removeAttribute("open");
        }
      });
    }

    if (btnsGuide.length && modalGuide) {
      btnsGuide.forEach(function (bg) {
        bg.addEventListener("click", function () {
          if (typeof modalGuide.showModal === "function") modalGuide.showModal();
          else modalGuide.setAttribute("open", "");
        });
      });
      if (btnFermerGuide) {
        btnFermerGuide.addEventListener("click", function () {
          if (typeof modalGuide.close === "function") modalGuide.close();
          else modalGuide.removeAttribute("open");
        });
      }
      modalGuide.addEventListener("click", function (e) {
        if (e.target === modalGuide) {
          if (typeof modalGuide.close === "function") modalGuide.close();
          else modalGuide.removeAttribute("open");
        }
      });
    }

    // 3d. Ajout au panier + Ouverture immédiate du tiroir panier style Harper
    function construireItemsSelectionnes() {
      var idxP = indicePalierChoisi();
      var palierActif = paliers[idxP];
      var lignesVar = palierActif ? $$(".lx-palier__ligne-var", palierActif) : [];
      var Regroupement = {};
      var ordreIds = [];

      if (lignesVar.length) {
        lignesVar.forEach(function (l) {
          var sc = $("[data-lx-select-couleur]", l);
          var st = $("[data-lx-select-taille]", l);
          var c = sc ? sc.value : couleurActive;
          var t = st ? st.value : tailleActive;
          var vr = trouverVariante(c, t);
          if (vr) {
            if (!Regroupement[vr.id]) {
              Regroupement[vr.id] = 0;
              ordreIds.push(vr.id);
            }
            Regroupement[vr.id] += 1;
          }
        });
      }

      if (!ordreIds.length) {
        var vDef = trouverVariante(couleurActive, tailleActive);
        if (vDef) {
          var infoP = infoPalier([vDef], vDef, idxP) || { idVar: vDef.id, qSend: 1 };
          return [{ id: +(infoP.idVar || vDef.id), quantity: infoP.qSend || 1 }];
        }
        return [];
      }

      return ordreIds.map(function (id) {
        return { id: +id, quantity: Regroupement[id] };
      });
    }

    function ajouterAuPanier() {
      var items = construireItemsSelectionnes();
      if (!items.length) return;
      var qteTotale = items.reduce(function (s, i) { return s + i.quantity; }, 0);

      if (bouton) bouton.disabled = true;
      if (boutonCollante) boutonCollante.disabled = true;
      if (retour) retour.textContent = "";

      if (window.location.protocol.indexOf("http") !== 0) {
        items.forEach(function (it) {
          var v = indexVariantesGlobal[it.id] || variantes[0] || {};
          memoirePanierLocal.items.push({
            key: String(it.id),
            variant_id: it.id,
            quantity: it.quantity,
            product_title: ($(".lx-titre-produit", fiche) || {}).textContent || "",
            variant_title: (v.opt1 || "") + " / " + (v.opt2 || ""),
            image: v.thumb || v.img || "",
            price: v.prixCents || 8490,
            original_price: v.pleinCents || 13490,
            final_line_price: (v.prixCents || 8490) * it.quantity
          });
        });
        memoirePanierLocal.item_count = memoirePanierLocal.items.reduce(function (s, i) { return s + i.quantity; }, 0);
        memoirePanierLocal.total_price = memoirePanierLocal.items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
        if (bouton) bouton.disabled = false;
        if (boutonCollante) boutonCollante.disabled = false;
        ouvrirPanier();
        return;
      }

      fetch(racine() + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (bouton) bouton.disabled = false;
          if (boutonCollante) boutonCollante.disabled = false;
          if (!res.ok) {
            if (retour) retour.textContent = (retour.getAttribute("data-ko") || "") + (res.j && res.j.description ? " " + res.j.description : "");
            return;
          }
          fetch(racine() + "cart.js", { headers: { "Accept": "application/json" } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (c) {
              if (c) rendrePanier(c);
              ouvrirPanier(!!c);
            })
            .catch(function () { ouvrirPanier(false); });
        })
        .catch(function () {
          if (bouton) bouton.disabled = false;
          if (boutonCollante) boutonCollante.disabled = false;
          if (retour) retour.textContent = retour.getAttribute("data-ko") || "";
        });
    }

    if (bouton) bouton.addEventListener("click", ajouterAuPanier);
    if (boutonCollante) boutonCollante.addEventListener("click", ajouterAuPanier);

    // 3e. Barre d'achat collante (Sticky Bar)
    var barreCollante = $("[data-lx-collante]", fiche);
    if (barreCollante && bouton && "IntersectionObserver" in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var horsVue = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          barreCollante.hidden = !horsVue;
        });
      }, { threshold: 0 });
      obs.observe(bouton);
    }
  }

  function gestClicGlobal(e) {
    if (!e.target || !e.target.closest || !e.target.closest("[data-lx-dd]")) {
      $$("[data-lx-dd].is-open").forEach(function (dd) {
        dd.classList.remove("is-open");
        var b = $("[data-lx-dd-btn]", dd);
        var m = $("[data-lx-dd-menu]", dd);
        if (b) b.setAttribute("aria-expanded", "false");
        if (m) m.hidden = true;
      });
    }
    var a = e.target.closest && e.target.closest("[data-lx-vers-offre]");
    if (a) {
      var cible = document.querySelector("[data-lx-offre]");
      if (cible) {
        e.preventDefault();
        cible.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    var btnMenu = e.target.closest && e.target.closest("[data-lx-ouvrir-menu]");
    if (btnMenu) {
      var tiroirMenu = document.querySelector("[data-lx-tiroir-menu]");
      if (tiroirMenu) {
        if (typeof tiroirMenu.showModal === "function") tiroirMenu.showModal();
        else tiroirMenu.setAttribute("open", "");
      }
      return;
    }

    var btnFermerMenu = e.target.closest && e.target.closest("[data-lx-fermer-menu]");
    if (btnFermerMenu) {
      var dlgMenu = btnFermerMenu.closest("dialog");
      if (dlgMenu) {
        if (typeof dlgMenu.close === "function") dlgMenu.close();
        else dlgMenu.removeAttribute("open");
      }
      return;
    }

    var btnRemonter = e.target.closest && e.target.closest("[data-lx-remonter]");
    if (btnRemonter) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    var btnPanier = e.target.closest && e.target.closest("[data-lx-ouvrir-panier]");
    if (btnPanier) {
      var panierEl = document.querySelector("[data-lx-panier]");
      if (panierEl) {
        e.preventDefault();
        ouvrirPanier();
      }
      return;
    }

    var btnFermerPanier = e.target.closest && e.target.closest("[data-lx-panier-fermer]");
    if (btnFermerPanier) {
      e.preventDefault();
      fermerPanier();
      return;
    }

    var btnQtePanier = e.target.closest && e.target.closest("[data-lx-panier-qte]");
    if (btnQtePanier) {
      var delta = parseInt(btnQtePanier.getAttribute("data-lx-panier-qte") || "0", 10);
      var qAct = parseInt(btnQtePanier.getAttribute("data-q") || "1", 10);
      var cle = btnQtePanier.getAttribute("data-cle");
      if (cle) majQuantitePanier(cle, qAct + delta);
      return;
    }

    var btnRetirerPanier = e.target.closest && e.target.closest("[data-lx-panier-retirer]");
    if (btnRetirerPanier) {
      var cleRet = btnRetirerPanier.getAttribute("data-cle");
      if (cleRet) majQuantitePanier(cleRet, 0);
      return;
    }

    var lienLegal = e.target.closest && e.target.closest("[data-lx-ouvrir-legal]");
    if (lienLegal && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      var idLegal = lienLegal.getAttribute("data-lx-ouvrir-legal");
      var dialog = idLegal ? document.querySelector("[data-lx-modal-legal=\"" + idLegal + "\"]") : null;
      if (dialog) {
        e.preventDefault();
        if (typeof dialog.showModal === "function") dialog.showModal();
        else dialog.setAttribute("open", "");
      }
      return;
    }

    var btnFermerLegal = e.target.closest && e.target.closest("[data-lx-fermer-legal]");
    if (btnFermerLegal) {
      var dlg = btnFermerLegal.closest("dialog");
      if (dlg) {
        if (typeof dlg.close === "function") dlg.close();
        else dlg.removeAttribute("open");
      }
      return;
    }

    if (e.target && e.target.tagName === "DIALOG") {
      if (typeof e.target.close === "function") e.target.close();
      else e.target.removeAttribute("open");
    }
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") fermerPanier();
  });

  document.addEventListener("change", function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute("data-lx-select-pays")) {
      if (e.target.form) e.target.form.submit();
    }
  });

  function initSuiviKore() {
    var sv = document.getElementById("sv-sendungsverfolgung");
    if (sv) {
      sv.classList.add("lx", "lx-kore-suivi");
      var det = sv.querySelector("details[data-sv-search]");
      if (det) det.open = true;
    }
    var pol = document.querySelector(".shopify-policy__container");
    if (pol) {
      pol.classList.add("lx", "lx-policy-wrap");
    }
  }

  // GIF animé -> vidéo MP4 du même nom (10 à 20 fois plus légère : Shopify envoie le GIF brut de 3 à 4,5 Mo aux iPhone
  // sous iOS 17 et avant). La vidéo prend la place de l'image (même classe, l'image sert d'affiche). Si elle ne peut pas
  // jouer (fichier absent, mode économie d'énergie de l'iPhone), on remet l'image avec le GIF, comme avant.
  function lancerAnim(img, gif) {
    var mp4 = img.getAttribute("data-lx-anim-mp4");
    img.removeAttribute("data-lx-anim-mp4");
    var v = mp4 ? document.createElement("video") : null;
    if (!v || !v.canPlayType || !v.canPlayType("video/mp4")) { img.src = gif; return; }
    var repli = false;
    function auGif() {
      if (repli) return;
      repli = true;
      img.src = gif;
      if (v.parentNode) v.parentNode.replaceChild(img, v);
    }
    v.className = img.className;
    ["muted", "loop", "autoplay", "playsinline"].forEach(function (a) { v.setAttribute(a, ""); });
    v.muted = true;
    v.playsInline = true;
    v.setAttribute("aria-label", img.getAttribute("alt") || "");
    if (img.getAttribute("width")) v.setAttribute("width", img.getAttribute("width"));
    if (img.getAttribute("height")) v.setAttribute("height", img.getAttribute("height"));
    v.poster = img.currentSrc || img.src;
    v.addEventListener("error", auGif);
    v.src = mp4;
    img.parentNode.replaceChild(v, img);
    var lecture = v.play();
    if (lecture && lecture.catch) lecture.catch(function (e) { if (!e || e.name !== "AbortError") auGif(); });
  }

  function initGifsLazy(el) {
    var imgs = $$("[data-lx-gif-lazy]", el);
    if (!imgs.length) return;
    if ("IntersectionObserver" in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (ent) {
          if (ent.isIntersecting) {
            var im = ent.target;
            var u = im.getAttribute("data-lx-gif-lazy");
            if (u) {
              im.removeAttribute("data-lx-gif-lazy");
              lancerAnim(im, u);
            }
            obs.unobserve(im);
          }
        });
      }, { rootMargin: "200px 0px" });
      imgs.forEach(function (im) { obs.observe(im); });
    }
  }

  function init(el) {
    $$("[data-lx-fiche]", el).forEach(initFiche);
    initExpedition();
    initSuiviKore();
    initGifsLazy(el);
  }
  document.addEventListener("click", gestClicGlobal);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
